import React, { useEffect, useState } from "react";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import CustomDataTableSearch from "../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { searchOperations } from "../../../../services/operation/operationService";

function SearchOperation({ warehouseID = 0, onSelectOperation }) {
  const { reload } = useGlobalData();
  const [operations, setOperations] = useState([]);
  useEffect(() => {
    getOperationsData();
  }, [warehouseID, reload]);

  async function getOperationsData() {
    const response = await searchOperations(warehouseID);
    const { data } = response.data;
    setOperations(data.operationCards);
  }

  return (
    <CustomDataTableSearch
      data={operations}
      onRefreshData={() => {
        getOperationsData();
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectOperation(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectOperation(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "Operation Card ID",
          field: "ID",
          body: null,
          sortable: true,
        },
        {
          header: "Operation Card Name",
          field: "title",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.title} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Customer Name",
          field: "customer.customerName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis
                text={rowData.customer.customerName}
                maxLine="1"
              />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Batch Code",
          field: "batchCode",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.batchCode} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Assigned",
          field: "assignedUserName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.assignedUserName} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
      ]}
    />
  );
}

export default SearchOperation;
